import { render, staticRenderFns } from "./salesReturnReceipt.vue?vue&type=template&id=b2622b0c&scoped=true"
import script from "./salesReturnReceipt.vue?vue&type=script&lang=js"
export * from "./salesReturnReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2622b0c",
  null
  
)

export default component.exports